import { TFunction } from 'i18next';

export interface Riesgo {
    id: number;
    codigo: string;
    descripcion: string;
}

export interface Examen {
    id: number;
    nombre: string;
    frecuencia: string;
    cantidad: number;
    data: any;
}

export interface BatchEmployee {
    id: string;
    nombre: string;
    apellido: string;
    cuil: string;
    sector: string;
    puesto: string;
    estadoGestion: string;
    citaciones: {
        current: number;
        total: number;
    };
    turno: string | null;
    examenes: {
        current: number;
        total: number;
    };
    riesgos: Riesgo[];
    asistencia: string;
}

export interface Establecimiento {
    organismoCentralId: number | undefined;
    codigoSRT: string;
    id: number;
    numero: string;
    nombre: string;
    organismo?: Organismo;
}

export interface Organismo {
    id: number;
    nombre: string;
    organismoCentral?: OrganismoCentral;
}

export interface OrganismoCentral {
    id: number;
    nombre: string;
    contrato: string;
}
export interface ExamenApi {
    idExamen: number;
    idTipoFrecuencia: number;
    periodo: string;
    cantidad: number;
    examenMedico: {
        id: number;
        descripcion: string;
        frecuencia: string;
    };
}

export interface ExamenesRiesgoResponse {
    data: {
        idRiesgo: number;
    };
    examenes: ExamenApi[];
}

export interface Prestador {
    id: number;
    razonSocial: string;
    direccion: string | null;
    telefono: string | null;
    email: string | null;
    localidad: {
        id: number;
        nombre: string;
        codigoPostal: number;
        departamento: number;
        provincia: {
            id: number;
            nombre: string;
        };
    } | null;
    cuit: string;
    tiposPrestador: {
        id: number;
        nombre: string;
    }[];
}

export interface Localidad {
    id: number;
    nombre: string;
    codigoPostal: string;
    localidades: any;
}

export interface AsignarExamenPayload {
    idsEmpleados: number[];
    idRiesgo: number;
}

export interface AsignarPrestadorPayload {
    idPrestador: number;
    idsBatches: number[];
}

export interface BatchDetailRisk {
    codigo: number;
    descripcion: string;
}

export interface BatchDetailExamenes {
    realizados: number;
    total: number;
}

export interface BatchDetail {
    nombre: string;
    apellido: string;
    cuil: string;
    sector: string;
    puesto: string;
    estadoGestion: string;
    citaciones: number;
    turnoAsignado: string;
    examenes: BatchDetailExamenes;
    riesgos: BatchDetailRisk[];
    asistencia: string;
}

export const getYesNoOptions = (t: TFunction) => [
    { id: 1, nombre: t('general.YES'), value: true },
    { id: 2, nombre: t('general.NO'), value: false }
];

export enum EstadoExpuestoEnum {
    PENDIENTE = 1,
    ASIGNADO = 2,
    CONVOCADO = 3,
    TURNO_ASIGNADO = 4,
    CON_RESULTADO = 5,
    PENDIENTE_APTITUD = 6
}

export const TAB_INDEX_TO_ESTADO: Record<number, number> = {
    0: EstadoExpuestoEnum.PENDIENTE,
    1: EstadoExpuestoEnum.ASIGNADO,
    2: EstadoExpuestoEnum.CONVOCADO
};

export type SelectionStatus = {
    hasExam: boolean;
    hasPrestador: boolean;
    riesgoCodes: string[];
} | null;

export const getEstadoExpuestoOptions = (t: TFunction) => [
    { id: EstadoExpuestoEnum.PENDIENTE, nombre: t('estadoExpuesto.1') },
    { id: EstadoExpuestoEnum.ASIGNADO, nombre: t('estadoExpuesto.2') },
    { id: EstadoExpuestoEnum.CONVOCADO, nombre: t('estadoExpuesto.3') },
    { id: EstadoExpuestoEnum.TURNO_ASIGNADO, nombre: t('estadoExpuesto.4') },
    { id: EstadoExpuestoEnum.CON_RESULTADO, nombre: t('estadoExpuesto.5') },
    { id: EstadoExpuestoEnum.PENDIENTE_APTITUD, nombre: t('estadoExpuesto.6') }

];

export enum TipoPrestadorEnum {
    EXTRACCIONISTAS = 1,
    PRESTADORES_MEDICOS = 2,
    INFECTOLOGOS = 3,
    LABORATORIO = 4,
    ASOCIACIONES = 5
}

export enum BatchExpirationFilterEnum {
    EN_FECHA = 'en_fecha',
    PROXIMO = 'proximo',
    VENCIDO = 'vencido'
}

export enum EstadoAsistencia {
    PENDIENTE = 1,
    PRESENTE = 2,
    AUSENTE = 3,
    BAJA_LICENCIA = 4
}

export enum EstadoEmpleadoLote {
    PENDIENTE_PRESTADOR = 1,
    PENDIENTE_TURNO = 2,
    CITADO = 3,
    PENDIENTE_RESULTADOS = 4,
    POR_AUDITAR = 5,
    AUDITADO_PARCIAL = 6,
    AUDITADO = 7,
    AUSENTE_DEFINITIVO = 8
}

export const tiposPrestadorOptions = (t: TFunction) => [
    { id: TipoPrestadorEnum.EXTRACCIONISTAS, nombre: t('typesPrestadores.1') },
    { id: TipoPrestadorEnum.PRESTADORES_MEDICOS, nombre: t('typesPrestadores.2') },
    { id: TipoPrestadorEnum.INFECTOLOGOS, nombre: t('typesPrestadores.3') },
    { id: TipoPrestadorEnum.LABORATORIO, nombre: t('typesPrestadores.4') },
    { id: TipoPrestadorEnum.ASOCIACIONES, nombre: t('typesPrestadores.5') }
];
